import { readonly } from "@vue/composition-api";
import Vue from "vue";
// @ts-ignore
import luxon from "@/libs/luxon";
import { DateTime } from "luxon";

export type RootState = {
    signedCookiesExpiryDate: DateTime | null;
};

const state: RootState = {
    signedCookiesExpiryDate: null,
};

export function useCookies() {
    const setSignedCookies = (signedCookies: { [key: string]: string }) => {
        Object.entries(signedCookies).forEach(([key, value]: [string, string]) => {
            const hostname = window.location.hostname.split(".").slice(-2).join(".");

            // https://github.com/cmp-cc/vue-cookies
            Vue.prototype.$cookies.set(
                key.toString(), // keyName
                value.toString(), // value
                "Session", // expires
                "/", // path
                `.${hostname}`, // domain
                true, // secure
                "lax" // samesite
            );
        });

        // @NOTICE number of hours correspondents to the validaty of the AWS signed cookies from the assets microservice.
        state.signedCookiesExpiryDate = luxon.DateTime.now().plus({ hours: 24 });
    };

    return {
        state: readonly(state),

        setSignedCookies,
    };
}
